import { ReportStatus } from '@features/siteStatusV2/constants';

const MapStatusToDisplay: Record<ReportStatus, string> = {
  [ReportStatus.NEW]: 'report.status.new',
  [ReportStatus.OPEN]: 'report.status.open',
  [ReportStatus.RESOLVED]: 'report.status.resolved',
  [ReportStatus.STAGNANT]: 'report.status.stagnant',
  [ReportStatus.REJECTED]: 'report.status.rejected',
  [ReportStatus.NO_STATUS]: '-'
};

export default MapStatusToDisplay;
